// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3LoPK","author":"Table_author__2g3FM","authorImage":"Table_authorImage__3stew","unreadRow":"Table_unreadRow__1XEyg"};